<div class="panel__header">
  <div>
    <h2>{{ 'admin.audit.detail.title' | adminTranslate }}</h2>
  </div>
  <div class="header-actions">
    <ui-button variant="secondary" size="sm" [routerLink]="['/audit']">{{ 'admin.common.backToList' | adminTranslate }}</ui-button>
    @if (event?.effectiveUserId) {
      <ui-button variant="secondary" size="sm" [routerLink]="['/users', event?.effectiveUserId]">{{ 'admin.common.openAccount' | adminTranslate }}</ui-button>
    }
  </div>
</div>

@if (loading) {
  <p class="empty">{{ 'admin.audit.detail.loading' | adminTranslate }}</p>
} @else if (event; as currentEvent) {
  <div class="event-facts">
    <div class="event-facts__row event-facts__row--wide">
      <span>{{ 'admin.audit.detail.reason' | adminTranslate }}</span>
      <strong>{{ currentEvent.reason || ('admin.audit.noReason' | adminTranslate) }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.action' | adminTranslate }}</span>
      <strong>{{ actionLabel(currentEvent.actionType) }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.status' | adminTranslate }}</span>
      <strong [class.status--error]="!currentEvent.success">{{ currentEvent.success ? ('admin.common.status.success' | adminTranslate) : ('admin.common.status.error' | adminTranslate) }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.date' | adminTranslate }}</span>
      <strong>{{ currentEvent.occurredAt | date:'dd/MM/yyyy HH:mm:ss' }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.actor' | adminTranslate }}</span>
      <strong>{{ currentEvent.actorType || 'SYSTEM' }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.requestId' | adminTranslate }}</span>
      <strong class="mono">{{ currentEvent.requestId || ('admin.common.notAvailable' | adminTranslate) }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.supportSession' | adminTranslate }}</span>
      <strong class="mono">{{ currentEvent.supportSessionId || ('admin.common.none' | adminTranslate) }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.path' | adminTranslate }}</span>
      <strong class="mono">{{ currentEvent.requestPath || ('admin.common.notAvailable' | adminTranslate) }}</strong>
    </div>
    <div class="event-facts__row">
      <span>{{ 'admin.audit.detail.effectiveUser' | adminTranslate }}</span>
      <strong class="mono">{{ currentEvent.effectiveUserId || ('admin.common.notAvailable' | adminTranslate) }}</strong>
    </div>
    <div class="event-facts__row event-facts__row--wide">
      <span>{{ 'admin.audit.detail.entity' | adminTranslate }}</span>
      <strong>{{ currentEvent.entityType || 'N/A' }}{{ currentEvent.entityId ? (' · ' + currentEvent.entityId) : '' }}</strong>
    </div>
  </div>

  @if (currentEvent.requestId) {
    <div class="section-block">
      <h3>{{ 'admin.audit.detail.navigation' | adminTranslate }}</h3>
      <a class="inline-link" [routerLink]="['/audit']" [queryParams]="{ requestId: currentEvent.requestId }">{{ 'admin.audit.detail.requestEvents' | adminTranslate }}</a>
    </div>
  }

  @if (currentEvent.supportSessionId) {
    <div class="section-block">
      <h3>{{ 'admin.audit.detail.supportSession' | adminTranslate }}</h3>
      <a class="inline-link" [routerLink]="['/audit']" [queryParams]="{ supportSessionId: currentEvent.supportSessionId }">{{ 'admin.audit.detail.supportEvents' | adminTranslate }}</a>
    </div>
  }

  <div class="section-block">
    <div class="section-block__header">
      <h3>Comparaison</h3>
      <ui-button variant="secondary" size="sm" (click)="toggleRawJson()">
        {{ showRawJson ? 'Voir la comparaison' : 'Voir les JSON complets' }}
      </ui-button>
    </div>

    @if (showRawJson) {
      <div class="raw-json-grid raw-json-grid--full">
        <div class="raw-json-card">
          <div class="raw-json-card__title">{{ 'admin.audit.detail.before' | adminTranslate }}</div>
          <pre class="raw-json-pre">{{ prettyJson(currentEvent.beforeJson) }}</pre>
        </div>
        <div class="raw-json-card">
          <div class="raw-json-card__title">{{ 'admin.audit.detail.after' | adminTranslate }}</div>
          <pre class="raw-json-pre">{{ prettyJson(currentEvent.afterJson) }}</pre>
        </div>
        <div class="raw-json-card raw-json-card--wide">
          <div class="raw-json-card__title">{{ 'admin.audit.detail.diff' | adminTranslate }}</div>
          <pre class="raw-json-pre">{{ prettyJson(currentEvent.diffJson) }}</pre>
        </div>
      </div>
    } @else if (canRenderStructuredComparison) {
      <div class="diff-compare">
        <div class="diff-compare__header diff-compare__header--path">Champ</div>
        <div class="diff-compare__header">{{ 'admin.audit.detail.before' | adminTranslate }}</div>
        <div class="diff-compare__header">{{ 'admin.audit.detail.after' | adminTranslate }}</div>

        @for (row of changedJsonComparisonRows; track row.path) {
          <div class="diff-row" [class.diff-row--added]="row.change === 'added'" [class.diff-row--removed]="row.change === 'removed'" [class.diff-row--modified]="row.change === 'modified'">
            <div class="diff-cell diff-cell--path">
              <strong>{{ row.path }}</strong>
            </div>
            <div class="diff-cell diff-cell--before" [class.diff-cell--empty]="row.before === null">
              {{ row.before ?? '—' }}
            </div>
            <div class="diff-cell diff-cell--after" [class.diff-cell--empty]="row.after === null">
              {{ row.after ?? '—' }}
            </div>
          </div>
        }
      </div>
    } @else {
      <p class="empty">{{ 'admin.audit.detail.noStructuredDiff' | adminTranslate }}</p>
    }
  </div>
}
